import React from 'react'
import './home.css'
import Social from './Social'
import Data from './Data'
import ScrollDown from './ScrollDown'
import { useInView } from 'react-intersection-observer'
import { useEffect } from 'react'


function Home() {

  const { ref, inView } = useInView();

  useEffect(() => {

    if (inView) {
      document.querySelector(".home__img").style.transform = "translateX(0px)"
      document.querySelector(".home__img").style.opacity = 1
    }
    else {
      document.querySelector(".home__img").style.transform = "translateX(200px)"
      document.querySelector(".home__img").style.opacity = 0
    }

  }, [inView]);

  return (
    <section className="home section" id="home">
      <div className="home__container container">


        <div className="home__content grid">
          <Social />
          

          <div className="home__img" ref={ref}></div>

          <Data />

        </div>

        <ScrollDown />
      </div>


    </section>
  )
}

export default Home